// First of all on purpose: with REACT_APP_ENABLE_MSW it plants the session cookie the account reducer
// reads while ./store below is still being evaluated. It does nothing in any other build.
import './mocks/devSession';
import 'core-js/es';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import store from './store';
import './index.css';
import theme from './theme';
import history from './history';
import App from './routes';

const renderApp = () => {
  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Router>
    </Provider>,
    document.getElementById('root')
  );
};

const shouldEnableMocking =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_ENABLE_MSW === 'true';

if (shouldEnableMocking) {
  import('./mocks/browser').then(({ default: worker }) => {
    worker.start().then(() => {
      renderApp();
    });
  });
} else {
  renderApp();
}
